import { render, staticRenderFns } from "./inspectionTableImpr.vue?vue&type=template&id=31ef8173"
import script from "./inspectionTableImpr.vue?vue&type=script&lang=js"
export * from "./inspectionTableImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ef8173')) {
      api.createRecord('31ef8173', component.options)
    } else {
      api.reload('31ef8173', component.options)
    }
    module.hot.accept("./inspectionTableImpr.vue?vue&type=template&id=31ef8173", function () {
      api.rerender('31ef8173', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/inspectionTableImpr.vue"
export default component.exports